<div class="modal-header">
  <h6 class="mb-0 modal-title">{{ title | titlecase }}</h6>
  <button type="button" class="close" (click)="close()"><span>X</span></button>
</div>
<div class="container chat-window p-3">
  <!-- System Welcome Message -->
  <div class="text-center mb-3 system-msg">
    <h5>👋 Hello {{ user?.fname }}!</h5>
    <p class="text-muted">What would you like to do today?</p>
  </div>

  <!-- Messages -->
  <div class="messages">
    <div *ngFor="let msg of messages" class="mb-3">
      <!-- User Message -->
      <div *ngIf="msg.role === 'user'" class="d-flex justify-content-end">
        <div class="user-msg p-2 rounded shadow-sm">
          {{ msg.content }}
        </div>
      </div>

      <!-- Assistant Message -->
      <div
        *ngIf="msg.role === 'assistant' && msg.content.trim() !== ''"
        class="d-flex justify-content-start"
      >
        <div class="ai-msg p-2 rounded shadow-sm w-75">
          <!-- Editable mode -->
          <div *ngIf="msg.editing">
            <textarea
              class="form-control auto-resize mb-2"
              [(ngModel)]="msg.tempContent"
            ></textarea>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-sm btn-success me-1"
                (click)="saveEdit(msg)"
              >
                ✅ Save
              </button>
              <button
                class="btn btn-sm btn-secondary"
                (click)="cancelEdit(msg)"
              >
                ❌ Cancel
              </button>
            </div>
          </div>

          <!-- Normal mode -->
          <pre *ngIf="!msg.editing" class="mb-2">{{ msg.content }}</pre>

          <!-- Action buttons -->
          <div class="actions">
            <button
              class="btn btn-sm btn-outline-secondary me-1"
              (click)="copyMessage(msg.content)"
            >
              📋
            </button>
            <button
              *ngIf="!msg.editing"
              class="btn btn-sm btn-outline-primary"
              (click)="toggleEdit(msg)"
            >
              ✏️
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Typing Loader -->
  <div *ngIf="isLoading" class="ai-loader ms-2">
    <span class="dot"></span><span class="dot"></span><span class="dot"></span>
  </div>

  <!-- Input -->
  <div class="input-group mt-3">
    <textarea
      [(ngModel)]="userInput"
      class="form-control auto-resize"
      placeholder="Type your message..."
      [disabled]="isLoading"
    ></textarea>
    <button
      class="btn btn-primary"
      (click)="sendMessage()"
      [disabled]="isLoading"
    >
      {{ isLoading ? "..." : "Send" }}
    </button>
  </div>
</div>
